export default __webpack_public_path__ + "static/media/img17.03c96dcc.PNG";